import { render, staticRenderFns } from "./LeaderboardCreator.vue?vue&type=template&id=af58951e&scoped=true"
import script from "./LeaderboardCreator.vue?vue&type=script&lang=js"
export * from "./LeaderboardCreator.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardCreator.vue?vue&type=style&index=0&id=af58951e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af58951e",
  null
  
)

export default component.exports